export default __webpack_public_path__ + "static/media/ic_course.bf355654dd92591b44100f27adab86e2.svg";